module.exports = __webpack_public_path__ + "img/14.2c5e1d8a.png";